import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { ENVIRONMENT } from '../tokens';
import { RtcErrorHandler } from './error-handler';

const DUPLICATE_THRESHOLD_MS = 500;

@Injectable({ providedIn: 'root' })
export class RateLimiterInterceptorService implements HttpInterceptor {
  private lastRequestMap = new Map<string, { time: number }>();
  private excludedUrls = [
    /\/search\/new\/fs_counts/, // this is POST request with different payloads
  ];

  constructor(
    private errorHandler: RtcErrorHandler,
    @Optional()
    @Inject(ENVIRONMENT)
    private environment?: { ENV: 'production' | 'staging' | 'development' },
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if ('staging' === this.environment?.ENV && !this.isExcluded(req)) {
      this.trackDuplicates(req);
    }
    return next.handle(req);
  }

  private isExcluded(req: HttpRequest<any>): boolean {
    return this.excludedUrls.some(excludeRegex => excludeRegex.test(req.urlWithParams));
  }

  private trackDuplicates(req: HttpRequest<any>): void {
    const previousRequest = this.lastRequestMap.get(req.urlWithParams);
    const currentTime = Date.now();
    this.lastRequestMap.set(req.urlWithParams, { time: currentTime });
    if (!previousRequest) return;

    const diff = currentTime - previousRequest.time;
    if (diff > DUPLICATE_THRESHOLD_MS) return;

    const url = req.urlWithParams.replace(/\/(\d+?)(\/|$)/g, '/id/');
    this.errorHandler.trace(`Duplicate call "${url}"`, false);
    console.warn(`Duplicate call "${req.urlWithParams}". Diff: ${diff}ms`);
  }
}
